$(function () {
  $('[data-toggle="agro-popup"]').each(function() {
    const popupId = $(this).attr('data-popup-id');
    const displayTimeInit = parseInt($(this).attr('data-display-time-init'));
    const displayTimeRepeat = parseInt($(this).attr('data-display-time-repeat'));
    const $this = $(this);

    if(window.localStorage) {

      const dateToShowPopupAgain = localStorage.getItem(`popup${popupId}`);

      if (dateToShowPopupAgain > new Date().getTime()) {
        return;
      }

      let expires = new Date();
      expires = expires.setTime(expires.getTime() + ((60 * 60 * 24 * 1000) * displayTimeRepeat));
      localStorage.setItem(`popup${popupId}`, expires);
    }

    // Close popup on 'X' click
    $(this).on('click', '.popup-close', function () {
      $(this).parent().remove();
    });

    // Show popup after certain amount of time
    window.setTimeout(function () {
      $this.removeClass('hide');
    }, displayTimeInit * 1000);

  });
});